/**
 * Keyboard helpers for the on-canvas comment bubble.
 *
 * Extracted as a pure function so the Escape-to-close decision is unit-tested
 * without standing up a tldraw editor in jsdom (the listener wiring itself is
 * browser/epic verified). See CommentUtil's `component`.
 */

/**
 * Decide whether an Escape keydown should close the open canvas comment bubble.
 *
 * Returns false when the key isn't Escape, or when the `@`-mentions dropdown is
 * open: rc-mentions consumes Escape to close its own dropdown first, so a single
 * Escape should dismiss the dropdown rather than the whole comment bubble.
 */
export function shouldCloseCommentOnEscape(
  key: string,
  mentionsDropdownOpen: boolean,
): boolean {
  return key === "Escape" && !mentionsDropdownOpen;
}

/**
 * True when an rc-mentions suggestion dropdown is currently visible anywhere in
 * the document. rc-mentions toggles `rc-mentions-dropdown-hidden` on its portal
 * element rather than unmounting it, so presence alone is not enough.
 */
export function isMentionsDropdownOpen(doc: Document = document): boolean {
  return !!doc.querySelector(
    ".rc-mentions-dropdown:not(.rc-mentions-dropdown-hidden)",
  );
}
